export default __webpack_public_path__ + "static/media/Victor.f345527b.jpg";